module.exports = __webpack_public_path__ + "img/img57.62fca574.svg";